<template>
  <el-dialog
    :visible="detailDialogVisible"
    title="Banner详情"
    width="1000px"
    @open="openDialog"
    @close="closeDialog"
  >
    <el-form :model="bannerDetail" ref="bannerForm" class="banner-form" :rules="rules" label-width="200px">
      <!-- <el-form-item label="广告位置：" prop="type">
        <el-select :value="bannerDetail.type" @change="handleFormChange('type', $event)" placeholder="请选择">
          <el-option
            v-for="item in positionTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item> -->
<!--      <el-form-item label="key：" prop="key">-->
<!--        <el-input v-model="bannerDetail.key"></el-input>-->
<!--      </el-form-item>-->
      <el-form-item label="标题：" prop="title">
        <el-input :value="bannerDetail.title" @change="handleFormChange('title', $event)"></el-input>
      </el-form-item>
      <el-form-item label="描述：" prop="descriptions">
        <el-input type="textarea"
                  style="resize:none;"
                  :rows="5"
                  v-model="bannerDetail.descriptions"></el-input>
      </el-form-item>
      <el-form-item label="文件：" prop="imageUrl">
        <upload :value="bannerDetail.imageUrl" @change="handleFormChange('imageUrl', $event)" :data="{language: this.bannerDetail.language, platform: this.bannerDetail.platform}"></upload>
        <p class="size-tip">{{bannerDetail.type | imgSize}}</p>
      </el-form-item>
      <el-form-item label="跳转地址：" prop="linkUrl">
        <el-input :value="bannerDetail.linkUrl" @change="handleFormChange('linkUrl', $event)"></el-input>
      </el-form-item>
      <el-form-item label="活动：" prop="actType">
        <el-select  v-model="bannerDetail.actType" placeholder="活动名称">
          <el-option label="无" :key="0" :value="0"></el-option>
          <el-option label="七折抢购" :key="1"  :value="1"></el-option>
          <el-option label="交易挖矿" :key="2"  :value="2"></el-option>
          <el-option label="随机免单" :key="3" :value="3"></el-option>
          <el-option label="hash夺宝" :key="4"  :value="4"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="toggleDetailDialogVisible(false)">取消</el-button>
      <el-button type="primary" @click="handleSave('bannerForm')">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import Upload from 'components/upload';
import {SIZE_TIPS} from '../../constants.js';

export default {
  name: 'BannerDetail',
  props: ['value'],
  data() {
    return {
      rules: {
        title: [{ required: true, message: '标题不能为空！' }],
        imageUrl: [{ required: true, message: '文件不能为空！' }]
      }
    };
  },
  components: {
    Upload
  },
  computed: {
    ...mapState('BannerNewSetting', [
      'detailDialogVisible',
      'positionTypeList',
      'platformTypeList',
      'languageList'
    ]),
    ...mapGetters('BannerNewSetting', ['bannerDetail', 'bannerList'])
  },
  methods: {
    ...mapActions('BannerNewSetting', ['detail', 'update', 'list']),
    ...mapMutations('BannerNewSetting', [
      'toggleDetailDialogVisible',
      'setBannerDetail'
    ]),
    openDialog() {
      this.detail(this.value);
    },
    closeDialog() {
      this.toggleDetailDialogVisible(false);
    },
    handleFormChange(type, value) {
      this.setBannerDetail({
        ...this.bannerDetail,
        [type]: value
      });
    },
    handleSave(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.update(this.bannerDetail).then(() => {
            this.$message({
              message: '修改成功！',
              type: 'success'
            });
            this.toggleDetailDialogVisible(false);
            this.$emit('refresh');
          });
        }
      });
    }
  },
  filters: {
    imgSize(val) {
      return SIZE_TIPS['s' + parseInt(val)] && ('图片尺寸：' + SIZE_TIPS['s' + parseInt(val)]) || ' ';
    }
  }
};
</script>

<style lang="less" scoped>
.banner-form {
  margin-right: 100px;
}
</style>
